import { useContext } from "react";

import NetworkStatusContext from "~/providers/NetworkStatusContext";

export interface UseNetworkStatusReturn {
	isOnline: boolean;
}

const useNetworkStatus = (): UseNetworkStatusReturn => useContext(NetworkStatusContext);

export default useNetworkStatus;
